<template>

<div>
	<transition name="fade">
		<div class="modal saving" v-if="showAddingProducts">
			<div class="inner" :class="{ done: !addingSelectedProducts }">
				<loading v-if="addingSelectedProducts">Saving...</loading>
				<i class="fas fa-check" v-else-if="showAddingProducts"></i>
			</div>
		</div>
	</transition>
	<div v-if="!moveReservationMode" class="navigation">
		<div>
			<div v-if="view == 'detail'" class="back-button" @click="view = previousView"><i class="fas fa-angle-left"></i><span>Back to {{ previousView.capitalizeWords() }}</span></div>
			<div v-if="view == 'add_products'" class="back-button" @click="view = 'detail'"><i class="fas fa-angle-left"></i><span>Back to Detail</span></div>
		</div>
		<div class="left"><input type="date" v-model="gridDate" style="font-size: 1.9em; width: 9em; margin: 0;" @change="fetchData()"><div>Date</div></div>
		<div class="refresh" @click="refresh()"><i class="fas fa-history"></i><div>Refresh</div></div>
		<div class="show-grid-view" @click="view = 'grid';"><i class="fas fa-th"></i><div>Grid View</div></div>
		<div class="show-time-view" @click="view = 'time';"><i class="far fa-clock"></i><div>Time View</div></div>
	</div>
	<div v-else class="navigation">
		<button class="cancel-move" @click="moveReservationMode = false" v-if="moveReservationMode">Cancel Move</button>
		<div class="refresh disbled"><i class="fas fa-history"></i><div>Refresh</div></div>
		<div class="show-grid-view disbled"><i class="fas fa-th"></i><div>Grid View</div></div>
		<div class="show-time-view disbled"><i class="far fa-clock"></i><div>Time View</div></div>
	</div>
	<div class="main range-manager" :class="{ 'move-reservation-mode': moveReservationMode }" v-if="moveReservationMode || view == 'grid'">
		<div v-if="rangeTimes.length > 0" class="lanes">
			<div class="scroller">
				<div ref="timeColumn" class="time-column" :style="'margin-top: ' + marginTop + 'px;'">
					<div class="time-whiteout" :style="'margin-top: ' + Math.abs(marginTop) + 'px;'"></div>
					<div ref="timeRow" class="blank cell"></div>
					<div class="blank cell" style="height: 31px"></div>
					<div v-for="(rangeTime, index) in rangeTimes" ref="rangeRows" class="time cell"><span class="description">{{ rangeTime.description }}</span></div>
					<div ref="current_time_line" class="current-time"><span class="current-time-point"></span></div>
				</div>
				<div class="lanes-scroller">
					<div class="head" :style="laneHeadStyles">
						<div v-for="(baySet, index) in rangeLanes" class="bay" :style="'grid-template-columns: repeat(' + baySet.range_lanes.length + ', 112px);'">
							<div class="bay-description" :style="'grid-column: span ' + baySet.range_lanes.length + ';'">{{ baySet.bay }}</div>
							<div v-for="(rangeLane, headColumnIndex) in baySet.range_lanes" :ref="'rangeLane' + rangeLane.range_lane_id" :class="['cell', { 'first-column': headColumnIndex == 0, 'last-column': headColumnIndex == baySet.range_lanes.length - 1 }]">{{ rangeLane.description }}</div>
						</div>
					</div>
					<div ref="lanesColumn" :class="['lanes-columns', { 'move-reservation-mode': moveReservationMode }]" :style="laneStyles">
						<div v-for="(reservation, reservationIndex) in rangeReservations" class="range-reservation" :class="[ reservation.top < 1 ? 'hide-top' : '', getBlockColor(reservation.startTime, reservation.endTime, reservation.expired), moveReservationMode && isSelectedReservation(reservation) ? 'selected-reservation' : null ]"
							:style="'left: ' + reservation.left + 'px; top: ' + reservation.top + 'px; height: ' + reservation.height + 'px; grid-template-rows: repeat(' + reservation.height / 26 + ', 1fr);'"
							@click="setReservationDetails(reservation)">
							<div :class="['time-block', { 'past-time-block': reservation.startTime.isBefore(exactNow, 'minute')}]">
								{{ timeLeftFormatted(reservation.startTime, reservation.endTime, reservation.expired) }}
								<div class="reservation-name">{{ reservation.name }}</div>
							</div>
						</div>
						<template v-for="(rangeTime, rowIndex) in rangeTimes">
							<template v-for="(bay, bayIndex) in rangeLanes">
								<div ref="lanesRows" :class="['cell', { 'last-row': rowIndex == rangeTimes.length - 1, 'first-column': laneIndex == 0, 'last-column': laneIndex == rangeLanes.length - 1, 'disabled': rangeLane.internal_use_only }]" v-for="(rangeLane, laneIndex) in bay.range_lanes" @click="moveReservation(rangeLane, rangeTime)">
								</div>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
		<div class="time-controls">
			<div class="next" @click="updateSetTime('forward')"><i class="fas fa-caret-down"></i></div>
			<div class="home" @click="updateSetTime('now')"><i class="fas fa-sign-in-alt fa-rotate-270"></i></div>
			<div class="previous" @click="updateSetTime('backward')"><i class="fas fa-caret-up"></i></div>
		</div>
	</div>
	<div v-else-if="view == 'time'" class="main range-manager">
		<div v-if="rangeReservations.length > 0" class="time-view">
			<div class="reservation-time" v-for="(reservation, index) in rangeReservations" v-if="timeLeftMinutes(reservation.startTime, reservation.endTime) <= 15 && started(reservation.startTime) && !reservation.expired" @click="setReservationDetails(reservation)">
				<timer class="timer" :startTime="reservation.reservation_start_time" :timeLimit="reservation.duration" :openLanes="openLanes"></timer>
				<div class="description">
					<span>{{ reservation.bay }}</span>
					<h3>{{ reservation.lane }}</h3>
				</div>
			</div>
			<div class="reservation-time" v-for="(reservation, index) in rangeReservations" v-if="timeLeftMinutes(reservation.startTime, reservation.endTime) > 15  && started(reservation.startTime) && !reservation.expired" @click="setReservationDetails(reservation)">
				<timer class="timer" :startTime="reservation.reservation_start_time" :timeLimit="reservation.duration" :openLanes="openLanes"></timer>
				<div class="description">
					<span>{{ reservation.bay }}</span>
					<h3>{{ reservation.lane }}</h3>
				</div>
			</div>
		</div>
		<div v-else class="empty-list">No current reservations</div>
	</div>
	<div v-else-if="view == 'add_products'" class="main range-manager">
		<div class="add-products-view">
			<div class="controls">
				<select v-model="departmentFilter">
					<option :value="null">Filter Department</option>
					<option :value="departmentId" v-for="(department, departmentId) in departments">{{ department }}</option>
				</select>
				<div :class="['button', { disabled: addingSelectedProducts } ]" @click="addProductsToReservation()">Add Selected Items</div>
			</div>
			<div style="height: calc(100vh - 20em); overflow-y: scroll;">
				<ul class="range-products">
					<template v-for="(department, departmentId) in filteredRangeProducts">
						<li v-for="(product, index) in department" :class="{ selected: productSelected(product.product_id) > -1 }">
							<img :src="product.image_src">
							<span class="description">{{ product.description }}</span>
							<span class="upc">{{ product.upc }}</span>
							<span class="price">${{ product.price }}</span>
							<select :value="selectedProducts[productSelected(product.product_id)].quantity" v-if="productSelected(product.product_id) > -1" @change="updateSelectedProducts($event, product.product_id)">
								<option :value="quantity" v-for="quantity in productQuantity">{{ quantity }}</option>
							</select>
							<select :value="0" v-else @change="updateSelectedProducts($event, product.product_id)">
								<option :value="quantity" v-for="quantity in productQuantity">{{ quantity }}</option>
							</select>
						</li>
					</template>
				</ul>
			</div>
		</div>
	</div>
	<div class="main range-manager" v-else-if="view == 'detail' && !moveReservationMode">
		<div class="detail-view" v-if="currentReservation">
			<div class="range-session-detail">
				<div class="add-a-note" @click="showCustomerNote()"><i class="far fa-sticky-note"></i><span>Add Note</span></div>
				<div class="modal range-note-modal" v-if="noteModalShowing">
					<div class="inner">
						<h1>Add a Note:</h1>
						<textarea v-model="customerNote"></textarea>
						<div class="controls">
							<div class="button" @click="saveCustomerNote()">Save</div>
							<div class="button cancel" @click="noteModalShowing = false">Cancel</div>
						</div>
						<div v-if="previousCustomerNote" class="previous-note">
							<b>Previous Note: </b>
							{{ previousCustomerNote }}
						</div>
					</div>
				</div>

				<h1>{{ currentReservation.bay }}: {{ currentReservation.lane }}</h1>
				<label>Customer:
					<input type="text" v-model="currentReservationCustomer" readonly>
				</label>
				<label>Start Time:
					<div>
						<select class="time-select" v-model="currentReservation.startTimeHour" :disabled="currentReservation.checked_in">
							<option v-for="hour in hourArray" :value='hour'>{{ hour }}</option>
						</select>
						<span style="padding: 0 0.5em;">:</span>
						<select class="time-select" v-model="currentReservation.startTimeMinute" :disabled="currentReservation.checked_in">
							<option v-for="minute in minuteArray" :value='minute'>{{ minute }}</option>
						</select>
					</div>
				</label>
				<label>End Time:
					<div>
						<select class="time-select" v-model="currentReservation.endTimeHour" :disabled="currentReservation.checked_in">
							<option v-for="hour in hourArray" :value='hour'>{{ hour }}</option>
						</select>
						<span style="padding: 0 0.5em;">:</span>
						<select class="time-select" v-model="currentReservation.endTimeMinute" :disabled="currentReservation.checked_in">
							<option v-for="minute in minuteArray" :value='minute'>{{ minute }}</option>
						</select>
					</div>
				</label>
				<label v-if="currentReservation.checked_in">
					<div></div>
					<div style="margin: 0.5em 0 0 0;">Checked In</div>
				</label>
				<label v-if="actionTargetCustomerGroups.length > 0">Group:
					<select v-model="currentReservation.action_target_customer_group_id">
						<option v-for="(customerGroup, index) in actionTargetCustomerGroups" :value="customerGroup.id">{{ customerGroup.groupName }}</option>
					</select>
				</label>
			</div>
			<div v-if="currentReservation.checked_in" style="font-size: 1.5em; margin: 6em 0 0 2em;">Total Time<br>{{ formatMinutes(currentReservation.duration) }}</div>
			<timer v-else class="timer" :startTime="currentReservation.reservation_start_time" :timeLimit="currentReservation.duration" :openLanes="openLanes"></timer>
			<div v-if="!openLanes" class="adjust-time">
				<div class="button subtract-time" @click="changeAddTimeDuration('subtract')"><i class="fas fa-minus"></i></div>
				<div class="detail-time-remaining">
					{{ addTimeDuration.hours().toString().padStart(2, "0") }}:{{ addTimeDuration.minutes().toString().padStart(2, "0") }}
				</div>
				<div class="button add-time" @click="changeAddTimeDuration('add')"><i class="fas fa-plus"></i></div>
				<span style="position: absolute; font-size: 0.8em; text-align: center; bottom: 0; color: #666;">There are {{ currentReservation.blocks_available }} blocks available after this reservation.</span>
			</div>

			<div class="controls">
				<button class="button" @click="startSession()" v-if="!sessionIsStarted">
					<img v-if="actionTargetEnabled" src="@/assets/img/ActionTargetLogoSmall.png" style="position: absolute; left: 0.5em; height: 1.5em;"><span :style="actionTargetEnabled ? 'padding-left: 1em;' : ''">Start Session</span>
				</button>
				<button class="button" @click="endSession()" v-else>
					<img v-if="actionTargetEnabled" src="@/assets/img/ActionTargetLogoSmall.png" style="position: absolute; left: 0.5em; height: 1.5em;"><span :style="actionTargetEnabled ? 'padding-left: 1em;' : ''">End Session</span>
				</button>
				<button class="button" @click="moveReservationMode = true">Move</button>
				<button class="button" @click="view = 'add_products'">Add Items</button>
				<button class="button" @click="saveReservation()">Save</button>
			</div>
		</div>
	</div>
</div>

</template>

<script>
import Timer from '../../../components/Timer'
//import CDSTimePicker from '../../../components/CDSTimePicker'
export default {
	components: {
		'timer': Timer
	},
	data() {
		return {
			view: 'grid',
			showAddingProducts: false,
			previousView: null,
			showDetail: false,
			today: this.$moment(),
			gridDate: this.$moment().format('YYYY-MM-DD'),
			noteModalLoading: false,
			noteModalShowing: false,
			beginTime: this.$moment('0000', 'HHmm'),
			endTime: this.$moment('2345', 'HHmm'),
			setTime: false,
			now: null,
			exactNow: null,
			marginTop: 0,
			first: null,
			nowInterval: null,
			productId: null,
			reservationLanes: [],
			rangeReserved: [],
			rangeLanes: [],
			numLanes: 0,
			rangeHours: {},
			rangeReserved: [],
			rangeReservationsRefs: [],
			rangeInCart: [],
			openLanes: false,
			moveReservationMode: false,
			currentReservation: {
				reservation_end_time: null,
				order_item_id: null,
				range_lane_id: null,
				range_reservation_id: null,
				reservation_date: null,
				reservation_start_time: null,
				start_time: '',
				startTimeString: '',
				expired: false,
				action_target_session_id: '',
				action_target_customer_group_id: ''
			},
			addTimeDuration: null,
			currentReservationDuration: null,
			departments: [],
			departmentFilter: null,
			rangeProducts: [],
			selectedProducts: [],
			addingSelectedProducts: false,
			previousCustomerNote: '',
			customerNote: '',
			message: '',
			hourArray: [],
			minuteArray: [],
			actionTargetEnabled: false,
			actionTargetCustomerGroups: [],
			actionTargetContactGroup: '',
			sessionIsStarted: false
		}
	},
	created() {
		if (this.$route.query.reservation_date) {
			this.gridDate = this.$route.query.reservation_date
		}
		this.fetchData()
	},
	beforeRouteLeave: function(to, from, next) {
		clearTimeout(this.timeout)
		// Make sure to always call the next function, otherwise the hook will never be resolved
		// Ref: https://router.vuejs.org/en/advanced/navigation-guards.html
		next();
	},
	// beforeDestroy() {
	//     clearTimeout(this.timeout)
	// },
	watch: {
		view(newVal, oldVal) {
			if (newVal != 'add_products' && oldVal != 'add_products') {
				if (newVal != oldVal) {
					this.previousView = oldVal
				} else {
					this.previousView = null
				}
				if (newVal == 'grid') {
					this.refresh()
				}
			}
			// If we're moving to the add products view, fetch them first
			if (newVal == 'add_products') {
				this.fetchRangeProducts()
			}
			// If we've left the add products view, clear out selectedProducts for the next time around
			if (oldVal == 'add_products') this.selectedProducts = []
		}
	},
	computed: {
		rangeTimes() {
			let rangeTimes = []
			let time = this.$moment('0000', 'HHmm')
			let index = 0
			while(index < 96) {
				rangeTimes.push({
					description: (time.minutes() == 15 || time.minutes() == 45) ? '' : time.format('hh:mm a'),
					reservationDate: time.format('YYYY-MM-DD HH:mm:ss')
				})
				index++
				time.add(15, 'minutes')
			}
			return rangeTimes
		},
		laneHeadStyles() {
			return {
				width: 'calc(' + (this.rangeLanes.length * 8) + 'rem + 48px)',
				gridTemplateColumns: 'repeat(' + this.numLanes+ ')'
			}
		},
		laneStyles() {
			return {
				marginTop: (this.marginTop + 1) + 'px',
				width: 'calc(' + (this.numLanes * 8) + 'rem + 48px)',
				gridTemplateColumns: 'repeat(' + this.numLanes + ', 112px)'
			}
		},
		rangeReservations() {
			let rangeReservationList = []
			if (this.rangeReserved.length === 0 || !this.$refs) return rangeReservationList
			this.rangeReserved.forEach(reservation => {
				if ((this.view == 'time' && !reservation.expired) || this.view != 'time') {
					let startTime = this.$moment(reservation.reservation_start_time, 'HHmm')
					let endTime = this.$moment(reservation.reservation_end_time, 'HHmm')
					if (this.openLanes && reservation.checked_in) {
						endTime = startTime.clone().add(reservation.duration, 'minutes')
					} else if (!this.openLanes) {
						endTime = startTime.clone().add(reservation.duration, 'minutes')
					}
					let numBlocks = Math.floor(endTime.diff(startTime, "minutes") / 15)
					let blocks = []
					for (var i = 0; i < numBlocks; i++) blocks.push({
						startTime: startTime.clone().add(15 * i, 'minutes'),
						endTime: endTime.clone().subtract(15 * ((numBlocks - 1) - i), 'minutes')
					});
					rangeReservationList.push({
						top: (startTime.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) * 26,
						left: (this.$refs['rangeLane' + reservation.range_lane_id][0]) ? this.$refs['rangeLane' + reservation.range_lane_id][0].offsetLeft : 0,
						height: Math.max(((endTime.diff(startTime, 'minutes') / 15) * 26), 52),
						rangeLaneId: reservation.range_lane_id,
						reservation_date: reservation.reservation_date + ' ' + startTime.format('HH:mm:00'),
						name: reservation.first_name + ' ' + reservation.last_name,
						startTime: startTime,
						endTime: endTime,
						blocks: blocks,
						...reservation
					})
				}
			})
			return rangeReservationList
		},
		rangeReservationsByLaneId() {
			let rangeReservations = {}
			if (this.rangeReserved.length === 0) return rangeReservations
			this.rangeReserved.forEach(reservation => {
				let startTime = this.$moment(reservation.reservation_start_time, 'HHmm')
				let endTime = this.$moment(reservation.reservation_end_time, 'HHmm')
				if (!rangeReservations[reservation.range_lane_id]) rangeReservations[reservation.range_lane_id] = {}
				rangeReservations[reservation.range_lane_id][startTime.format('HHmm')] = {
					reservation_date: reservation.reservation_date + ' ' + startTime.format('HH:mm:00'),
					startTime: startTime,
					endTime: endTime,
					...reservation
				}
			})
			return rangeReservations
		},
		currentReservationTimeLeft() {
			return this.timeLeftMinutes(this.currentReservation.startTime, this.currentReservationEndTime)
		},
		productQuantity() {
			var quantity = []
			for (var i = 0; i < 20; i++) {
				quantity.push(i)
			}
			return quantity
		},
		filteredRangeProducts() {
			if (!this.departmentFilter) return this.rangeProducts
			return {
				[this.departmentFilter]: this.rangeProducts[this.departmentFilter]
			}
		}
	},
	methods: {
		fetchData() {
			this.numLanes = 0
			this.apiCall({ destination: 'get_range_lanes' }).then(obj => {
				this.openLanes = obj.range_lanes_open
				this.rangeLanes = obj.range_lanes
				for (let bay in this.rangeLanes) {
					this.numLanes += this.rangeLanes[bay]['range_lanes'].length
				}
				this.actionTargetEnabled = obj.action_target_enabled
				this.apiCall({ destination: 'get_range_reservations', data: { reservation_date: this.gridDate } }).then(obj => {
					this.rangeReserved = obj.range_reserved
					this.setNow()
					//this.setExactNow()
					this.scrollToNow()
					setTimeout(() => {
						if (this.$refs['current_time_line'] && this.$refs['current_time_line'].style) {
							let nowLine = ((this.exactNow.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) * 26) + 82
							this.$refs['current_time_line'].style.top = nowLine + 'px'
						}
					}, 100)
					if (this.$route.query.range_reservation_id || this.$route.query.shopping_cart_reservation_id) {
						var searchTerm = Object.keys(this.$route.query)[0]
						var searchValue = this.$route.query[searchTerm]
						var reservation = this.rangeReservations.find(reservation => {
							return reservation[searchTerm] == searchValue
						})
						this.setReservationDetails(reservation)
					}
				}).catch(err => {
					console.log(err)
				})
			}).catch(err => {
				console.log(err)
			})
		},
		calculateRangeTimes() {
			this.rangeTimes = []
			let time = this.$moment('0000', 'HHmm')
			let index = 0
			while(index < 96) {
				this.rangeTimes.push({
					description: (time.minutes() == 15 || time.minutes() == 45) ? '' : time.format('HH:mm'),
					reservationDate: time.format('YYYY-MM-DD HH:mm:ss')
				})
				index++
				time.add(15, 'minutes')
			}
		},
		refresh() {
			clearTimeout(this.timeout)
			this.view = 'grid'
			this.apiCall({ destination: 'get_range_reservations', data: { reservation_date: this.gridDate } }).then(obj => {
				this.rangeReserved = obj.range_reserved
				this.setNow()
				//this.setExactNow()
				this.scrollToNow()
				if (this.$refs['current_time_line'] && this.$refs['current_time_line'].style) {
					let nowLine = ((this.exactNow.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) * 26) + 82
					this.$refs['current_time_line'].style.top = nowLine + 'px'
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setNow() {
			clearTimeout(this.timeout)
			// If we're scrolling forwards or backwards don't update the view right now
			if (this.setTime || this.moveReservationMode) return
			this.now = this.$moment().seconds(0).minutes(Math.floor(parseInt(this.$moment().minutes()) / 15) * 15)
			if (this.openLanes) {
				this.marginTop = (((this.now.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) - 9) * -25) + 27
			} else {
				this.marginTop = (((this.now.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) - 4) * -25) + 27
			}
			this.exactNow = this.$moment()
			if (this.exactNow && this.$refs['current_time_line'] && this.$refs['current_time_line'].style) {
				let nowLine = ((this.exactNow.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) * 26) + 82
				this.$refs['current_time_line'].style.top = nowLine + 'px'
			}
			this.timeout = setTimeout(() => {
				this.setNow()
			}, 10000)
		},
		setExactNow() {
			this.exactNow = this.$moment()
		},
		scrollToNow() {
			// this.setExactNow()
			this.exactNow = this.$moment()
			if (this.openLanes) {
				this.marginTop = (((this.now.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) - 9) * -25) + 27
			} else {
				this.marginTop = (((this.now.diff(this.$moment('0000', 'HHmm'), 'minutes') / 15) - 4) * -26) + 78
			}
		},
		updateSetTime(direction) {
			switch (direction) {
				case 'now':
					this.setTime = false
					this.setNow()
					break;
				case 'forward':
					if (this.endTime.diff(this.now, 'minutes') <= 0) return
					this.now.add(60, 'minutes')
					break;
				case 'backward':
					if (this.now.diff(this.beginTime, 'minutes') <= 0) return
					this.now.subtract(60, 'minutes')
					break;
			}
			this.setTime = true
			this.scrollToNow()
		},
		timeLeftMinutes(startTime = null, endTime) {
			let timeLeft = (startTime) ? this.$moment.duration(endTime.diff(startTime)) : this.$moment.duration(endTime.diff(this.$moment()))
			return timeLeft.as("minutes")
		},
		timeLeftFormatted(startTime = null, endTime, expired = false) {
			if (this.openLanes) {
				if (expired) {
					return `${this.$moment.duration(this.timeLeftMinutes(startTime, endTime), "minutes").hours().toString().padStart(2, "0")}:${this.$moment.duration(this.timeLeftMinutes(startTime, endTime), "minutes").minutes().toString().padStart(2, "0")}`
				} else {
					return `${this.$moment.duration(this.$moment().diff(startTime)).hours().toString().padStart(2, "0")}:${this.$moment.duration(this.$moment().diff(startTime)).minutes().toString().padStart(2, "0")}`
				}
			} else {
				if (endTime.isBefore(this.exactNow)) return "00:00"
				if (startTime && startTime.isAfter(this.exactNow)) return `${this.$moment.duration(endTime.diff(startTime)).hours().toString().padStart(2, "0")}:${this.$moment.duration(endTime.diff(startTime)).minutes().toString().padStart(2, "0")}`
				return `${this.$moment.duration(this.timeLeftMinutes(startTime, endTime), "minutes").hours().toString().padStart(2, "0")}:${this.$moment.duration(this.timeLeftMinutes(startTime, endTime), "minutes").minutes().toString().padStart(2, "0")}`
			}
		},
		started(startTime) {
			return this.exactNow.isSameOrAfter(startTime)
		},
		getBlockColor(startTime, endTime, expired) {
			if (this.openLanes) {
				if (expired) {
					return "gray"
				} else {
					return "green"
				}
			} else {
				if (!expired && startTime.isSameOrBefore(this.exactNow)) {
					let minutes = endTime.diff(this.exactNow, 'minutes')
					if (minutes < 15 && minutes > 5) return "yellow";
					if (minutes <= 5) return "red";
					return "green";
				}
				return "gray";
			}
		},
		getTimerColor(startTime, endTime) {
			switch (this.getBlockColor(startTime, endTime)) {
				case 'green':
					return '#80bf7f';
					break;
				case 'yellow':
					return 'rgba(252, 185, 26, 0.5)';
					break;
				case 'red':
					return 'rgba(252, 74, 26, 0.5)';
					break;
				case 'black':
					return '#000';
					break;
			}
		},
		rotation(startTime, endTime) {
			let minutes = endTime.diff(this.exactNow, 'minutes');
			var degrees;
			if (minutes > 0 && minutes <= 60) {
				degrees = ((60 - minutes) / 60) * 360;
			} else if (minutes <= 0) {
				degrees = 0;
			} else {
				degrees = 360;
			}
			return degrees;
		},
		timerStyle(startTime, endTime) {
			return {
				'background': (this.rotation(startTime, endTime) <= 0) ? 'rgba(252, 74, 26, 1)' : '-webkit-linear-gradient(left, #BBB 50%, ' + this.getTimerColor(startTime, endTime) + ' 0%)',
				'transform': 'rotate(' + this.rotation(startTime, endTime) + 'deg)'
			}
		},
		maskStyle(startTime, endTime) {
			let rotate = (this.rotation(startTime, endTime) > 180) ? -180 : 0;
			return {
				'background': (this.rotation(startTime, endTime) > 0) ? '#BBB' : this.getTimerColor(startTime, endTime),
				'transform': 'rotate(' + rotate + 'deg)'
			}
		},
		setReservationDetails(reservation) {
			if (this.moveReservationMode) return
			console.log(reservation)
			this.sessionIsStarted = false
			this.currentReservation = {reservation_end_time: null, order_item_id: null, range_lane_id: null, range_reservation_id: null, reservation_date: null, reservation_start_time: null, expired: false}
			if (this.moveReservationMode && reservation) {
				return false
			}
			this.currentReservation = this.$copy(reservation)
			this.currentReservation.action_target_session_id = ''
			if (this.actionTargetEnabled) {
				this.apiCall({ destination: 'get_action_target_session', data: { range_lane_id: reservation.rangeLaneId, contact_id: reservation.contact_id } }).then(obj => {
					this.currentReservation.action_target_session_id = obj.action_target_session_id
					this.actionTargetCustomerGroups = obj.action_target_customer_groups
					this.currentReservation.action_target_customer_group_id = obj.action_target_customer_group_id || this.actionTargetCustomerGroups[0].id
				}).catch(err => {
					console.log(err);
				})
			}

			this.currentReservation.startTime = (this.currentReservation.start_time) ? this.$moment(this.currentReservation.start_time, 'HHmm') : this.$moment(this.currentReservation.reservation_start_time, 'HHmm')
			this.currentReservation.endTime = (this.currentReservation.end_time) ? this.$moment(this.currentReservation.end_time, 'HHmm') : this.$moment(this.currentReservation.reservation_end_time, 'HHmm')
			this.currentReservation.blocks_available = this.blocksAvailable(reservation)
			this.currentReservationDuration = this.$moment.duration(reservation.duration, "minutes")
			this.currentReservationCustomer = reservation.first_name + ' ' + reservation.last_name
			this.addTimeDuration = this.$moment.duration(0, 'minutes') // initiate add time as zero
			this.currentReservation.rounds = reservation.rounds || ''

			// set hours for start / end time inputs
			this.hourArray = []
			for (let i = 0; i < this.rangeLanes.length; i++) {
				if (this.rangeLanes[i].product_id == reservation.product_id) {
					for (let hour = parseInt(this.rangeLanes[i].start_hour); hour < parseInt(this.rangeLanes[i].end_hour) + 100; hour += 100) {
						this.hourArray.push((hour / 100).toString().padStart(2, '0'))
					}
					break;
				}
			}
			// set minutes for start / end time inputs
			this.minuteArray = []
			for (let i = 0; i < 60; i++) {
				this.minuteArray.push(i.toString().padStart(2, '0'))
			}

			this.currentReservation.startTimeHour = this.currentReservation.startTime.format('HH')
			this.currentReservation.startTimeMinute = this.currentReservation.startTime.format('mm')
			this.currentReservation.endTimeHour = this.currentReservation.endTime.format('HH')
			this.currentReservation.endTimeMinute = this.currentReservation.endTime.format('mm')

			if (this.currentReservation.action_target_session_id) {
				this.sessionIsStarted = true
			}
			if (this.currentReservation.start_time && !this.currentReservation.end_time) {
				this.sessionIsStarted = true
			}
			if (this.currentReservation.end_time > 0 && this.currentReservation.end_time < this.$moment().format('HHmm')) {
				this.sessionIsStarted = true
			}

			this.view = 'detail'
		},
		blocksAvailable(reservation) {
			// how many blocks available after this reservation?
			let nextBlock = reservation.reservation_end_time;
			let thisRangeReservationId = reservation.range_reservation_id
			let thisShoppingCartReservationId = reservation.shopping_cart_reservation_id
			let thisRangeLaneId = reservation.range_lane_id
			let a = this.$moment(nextBlock, 'HHmm');
			let b = this.$moment(2400, 'HHmm');
			let blocksTillMidnight = b.diff(a, 'minutes') / 15
			//console.log('Blocks till midnight: ' + blocksTillMidnight)
			let blocksAvailable = 0;
			let blockTaken = false
			for (let block = 0; block < blocksTillMidnight; block++) {
				for (let i = 0; i < this.rangeReserved.length; i++) {
					if (this.rangeReserved[i]['range_lane_id'] == thisRangeLaneId && (this.rangeReserved[i]['range_reservation_id'] != thisRangeReservationId || this.rangeReserved[i]['shopping_cart_reservation_id'] != thisShoppingCartReservationId)) {
						// same lane, not this reservation, so check start time against block
						if (this.rangeReserved[i]['reservation_start_time'] >= nextBlock) {
							blockTaken = true
							break
						}
					}
				}
				if (blockTaken) {
					break
				}
				// increment to the next block
				blocksAvailable++
				nextBlock = this.$moment(nextBlock, 'HHmm').add(15, 'minutes').format('HHmm')
			}
			return blocksAvailable
		},
		isSelectedReservation(reservation) {
			if (reservation.shopping_cart_reservation_id && (this.currentReservation.shopping_cart_reservation_id == reservation.shopping_cart_reservation_id)) return true
			if (reservation.range_reservation_id && (this.currentReservation.range_reservation_id == reservation.range_reservation_id)) return true
			return false
		},
		changeAddTimeDuration(action) {
			switch (action) {
				case 'add':
					if (this.blocksAvailable(this.currentReservation) === 0) return false
					this.addTimeDuration.add(15, 'minutes')
					this.currentReservation.endTime.add(15, 'minutes')
					this.currentReservation.reservation_end_time = this.currentReservation.endTime.format('HHmm')
					break;
				case 'subtract':
					if (this.currentReservation.endTime.clone().subtract(15, 'minutes').diff(this.currentReservation.startTime, "minutes") < 15
						|| this.currentReservation.endTime.diff(this.exactNow, "minutes") < 15) return false
					// if (this.addTimeDuration == 0) return false
					this.addTimeDuration.subtract(15, 'minutes')
					this.currentReservation.endTime.subtract(15, 'minutes')
					break;
			}
		},
		saveReservation() {
			this.currentReservationDuration.add(this.addTimeDuration.minutes(), "minutes")
			let data = {
				range_reservation_id: this.currentReservation.range_reservation_id,
				reservation_date: this.currentReservation.reservation_date,
				range_lane_id: this.currentReservation.range_lane_id,
				shopping_cart_reservation_id: this.currentReservation.shopping_cart_reservation_id,
				duration: this.currentReservationDuration.as('minutes'),
				rounds: this.currentReservation.rounds,
				start_time: this.currentReservation.startTimeHour + this.currentReservation.startTimeMinute,
				end_time: this.currentReservation.endTimeHour + this.currentReservation.endTimeMinute,
				modify_session: this.addTimeDuration > 0
			}
			this.apiCall({ destination: 'save_item_range_reservation', data: data }).then(obj => {
				this.refresh()
				this.view = 'grid'
			}).catch(err => {
				console.log(err);
			})
		},
		startSession() {
			let data = {
				range_reservation_id: this.currentReservation.range_reservation_id,
				shopping_cart_reservation_id: this.currentReservation.shopping_cart_reservation_id,
				contact_id: this.currentReservation.contact_id,
				action_target_customer_group_id: this.currentReservation.action_target_customer_group_id,
				start_time: this.$moment().format('HHmm'),
				start_session: 1
			}
			this.apiCall({ destination: 'save_item_range_reservation', data: data }).then(obj => {
				this.refresh()
				this.view = 'grid'
			}).catch(err => {
				console.log(err);
			})
		},
		endSession() {
			let data = {
				range_reservation_id: this.currentReservation.range_reservation_id,
				shopping_cart_reservation_id: this.currentReservation.shopping_cart_reservation_id,
				end_time: this.$moment().format('HHmm'),
				end_session: 1
			}
			this.apiCall({ destination: 'save_item_range_reservation', data: data }).then(obj => {
				this.refresh()
				this.view = 'grid'
			}).catch(err => {
				console.log(err);
			})
		},
		moveReservation(rangeLane, rangeTime, laneIndex) {
			if (!this.moveReservationMode) return
			let reservation = {
				reservation_end_time: this.$moment(rangeTime.reservationDate).format('HHmm'),
				range_lane_id: rangeLane.range_lane_id,
				range_reservation_id: this.currentReservation.range_reservation_id
			}
			if (this.blocksAvailable(reservation) < this.currentReservation.duration / 15) return
			let data = {
				range_reservation_id: this.currentReservation.range_reservation_id,
				shopping_cart_reservation_id: this.currentReservation.shopping_cart_reservation_id,
				reservation_date: rangeTime.reservationDate,
				duration: this.currentReservationDuration.as('minutes'),
				start_time: '',
				end_time: '',
				range_lane_id: rangeLane.range_lane_id,
				current_range_lane_id: this.currentReservation.range_lane_id,
				end_session: this.currentReservation.action_target_session_id.length > 0
			}
			this.apiCall({ destination: 'save_item_range_reservation', data: data }).then(obj => {
				this.moveReservationMode = false
				this.refresh()
				this.view = 'grid'
			}).catch(err => {
				console.log(err);
			})
		},
		cancelReservation() {},
		inReservation(rangeLane, time) {
			if (Object.keys(this.reservationLanes).length == 0) return false

			for (var i = 0; i < Object.keys(this.reservationLanes).length; i++) {
				if (this.reservationLanes[i].rangeLane.range_lane_id == rangeLane.range_lane_id && this.reservationLanes[i].reservation_date == time) {
					return i
				}
			}
			return false
		},
		isReserved(rangeLaneId, reservationDate) {
			for (var i = 0; i < this.rangeReserved.length; i++) {
				if (this.rangeReserved[i]['range_lane_id'] == rangeLaneId && this.rangeReserved[i]['reservation_date'] == reservationDate) {
					return this.rangeReserved[i]
				}
			}
			return false
		},
		fetchRangeProducts() {
			this.apiCall({ destination: 'get_list_range_products', data: { contact_id: this.currentReservation.contact_id } }).then(obj => {
				this.rangeProducts = obj.range_products
				this.departments = obj.range_products_departments
			}).catch(err => {
				console.log(err);
			})
		},
		updateSelectedProducts(event, productId) {
			var index = this.selectedProducts.findIndex(product => product.product_id == productId)
			var value = parseInt(event.target.value)
			if (index == -1 && value > 0) {
				this.selectedProducts.push({
					product_id: productId,
					quantity: value
				})
			} else if (index > -1 && value > 0) {
				this.selectedProducts[index].quantity = value
			} else if (index > -1 && value === 0) {
				this.selectedProducts.splice(index, 1)
			} else {
				return
			}
		},
		productSelected(productId) {
			return this.selectedProducts.findIndex(product => product.product_id === productId)
		},
		addProductsToReservation() {
			if (this.addingSelectedProducts || this.selectedProducts.length == 0) {
				return
			}
			this.showAddingProducts = true
			this.addingSelectedProducts = true
			for (let i = 0; i < this.selectedProducts.length; i++) {
				this.apiCall({ destination: 'add_product_to_range_cart', data: { contact_id: this.currentReservation.contact_id, product_id: this.selectedProducts[i]['product_id'], quantity: this.selectedProducts[i]['quantity'] } }).then(obj => {
					this.addingSelectedProducts = false
					setTimeout(() => {
						this.showAddingProducts = false
					}, 2000)
					if (obj.status == 'error') {
						// oops!
					}
				}).catch(err => {
					console.log(err);
				})
			}
			this.selectedProducts = []
			this.addingSelectedProducts = false
		},
		myFilter: function() {
			this.isSelected = !this.isSelected;
		},
		showCustomerNote() {
			this.noteModalShowing = false
			this.apiCall({ destination: 'get_item_contact_note', data: { contact_id: this.currentReservation.contact_id } }).then(obj => {
				this.previousCustomerNote = obj.note
				this.noteModalShowing = true
			}).catch(err => {
				console.log(err);
			})
		},
		saveCustomerNote() {
			if (!this.customerNote) {
				return
			}
			this.apiCall({ destination: 'save_item_contact_note', data: { contact_id: this.currentReservation.contact_id, note: this.customerNote } }).then(obj => {
				if (obj.status == 'error') {
					this.message = obj.message
				} else {
					this.noteModalShowing = false
					this.customerNote = ''
				}
			}).catch(err => {
				console.log(err);
			})
		},
		formatMinutes(minutes) {
			return this.$moment.utc(this.$moment.duration(minutes, "minutes").asMilliseconds()).format("HH:mm")
		}
	}
}
</script>

<style lang="scss">
$orange: #d77325;
.container.range_memberships_module.range-manager {
	margin: 0;
	padding: 0;
}
.range-manager {
	position: relative;
	height: calc(100vh - 12em);
	.saving.modal {
		.inner {
			padding: 3rem;
			box-shadow: none;

			&.done {
				background: $orange;
				font-size: 4em;
				border-radius: 0.6em;
			}
			i {
				color: white;

			}
			.message {
				margin: 0;
			}
		}
	}

	.button {
		font-size: 1em;
		padding: 0.66em 0;
	}

	.lanes {
		overflow: hidden;
		position: relative;
		.scroller {
			display: grid;
			grid-template-columns: 7em 1fr;
			margin-left: 1em;
			// overflow-y: scroll;
			height: 74vh;
		}

		.cell {
			position: relative;
		}
		.time-column, .lanes-scroller {
			z-index: 99;
			margin-bottom: 1em;
			margin-top: 5px;
		}
		.time-column {
			margin-bottom: 3em;
			position: relative;

			.current-time {
				position: absolute;
				top: 0px;
				left: 5.66em;
				width: calc(100vw - 1em);
				border-bottom: 2px solid red;
				.current-time-point {
					position: absolute;
					top: -0.5em;
					left: 0;
					width: 1em;
					height: 1em;
					background: red;
					border-radius: 50%;
				}
			}

			.time-whiteout {
				position: absolute;
				background: white;
				width: 100%;
				z-index: 2;
				height: 75px;
			}
			.cell {
				height: 26px;
				&:not(.blank) {
					border-top: 2px dotted #CCC;
				}
			}
			.blank { height: 53px; }
			.time.cell {
				.description {
					display: block;
					font-weight: bold;
					margin-top: -9px;
					background: white;
					padding-left: 0.5em;
				}
			}
		}
		.range-reservation {
			position: absolute;
			color: white;
			font-weight: bold;
			font-size: 1.2em;
			padding: 5px 6px;
			z-index: 101;
			width: 111px;
			height: 3.3rem;
			border-top: 1px solid #b5b5b5;
			border-bottom: 1px solid #b5b5b5;
			border-radius: 8px;
			box-shadow: 0px 1px 4px 0px #b5b5b5;
			.reservation-name { font-size: 0.66em; }
			&.gray {
				background: rgba(109, 109, 109, 0.9);
			}
			&.green {
				background: rgba(8, 156, 29, 0.9); //#80bf7f
			}
			&.yellow {
				background: rgba(228, 192, 0, 0.9); //#efcd7e
			}
			&.red {
				background: rgba(202, 30, 0, 0.9); //#ce7f74
			}

			&.hide-top {
				align-items: end;
				padding: 0 0 1rem 0;
			}
			.time-block {
				height: 24px;
				width: 100%;
				position: absolute;
				bottom: 24px;
			}
		}
		.lanes-scroller {
			overflow-x: scroll;
			overflow-y: hidden;
			border-left: 1px solid black;
			position: relative;

			.cell {
				width: 112px;
				height: 26px;
				display: inline-block;
				font-size: 1.2em;
				font-weight: bold;
				text-align: center;
				color: white;
				border-left: solid #cccccc;
				border-right: solid #cccccc;
				border-top: dotted #cccccc;
				border-width: 2px 1px;
				&.first-column {
					border-left-width: 1px;
				}
				&.disabled {
					background: rgba(0, 0, 0, 0.1);	
				}
			}
		}
		.head {
			display: grid;
			grid-column-gap: 1rem;
			height: 78px;

			.bay {
				grid-row: 1;
				display: grid;
				grid-column-gap: 1rem;
				background: white;
				z-index: 103;

				.bay-description {
					grid-row: 1;
					padding: 0.25rem 0.5rem;
					border-left: 1px solid #cccccc;
					background: $orange;
					color: white;
					height: 26px;
				}

				.cell {
					z-index: 102;
					padding: 17px 0 10px 0;
					border: 1px solid #cccccc;
					border-top: none;
					color: #3a3a3a;
					height: 52px;
					// box-shadow: 0px 52px 0px 0px rgba(255, 255, 255, 0.6);
				}
			}
		}
		.lanes-columns {
			display: grid;
			grid-column-gap: 1rem;
			position: relative;

			// &.disabled {
			// 	background: rgba(0, 0, 0, 0.3);	
			// };

			.last-row {
				border-bottom: 1px solid black;
			}

			// Here's where the CSS for the reservations goes when moving
			&.move-reservation-mode {
				.range-reservation {
					// Normal reservation
					opacity: 0.5;

				}
				.range-reservation.selected-reservation {
					// Reservation we're moving
					border: 2px solid #9ecaed;
					border-radius: 7px;
					box-shadow: 0 0 10px #9ecaed;
					opacity: 1;
					z-index: 0; // So we can select a time underneath the reservation we're moving
				}
			}
		}
		.second-row {
			border-top-color: white !important;
		}
		.now-line {
			z-index: 100;
			position: absolute;
			width: 92%;
			height: 1px;
			border-bottom: 1px solid red;
			top: 6.6rem;
			left: 4rem;
		}
	}
	.time-controls {
		text-align: center;
		display: grid;
		grid-template-columns: 5fr 0.7fr 0.7fr 0.7fr 5fr;
		div {
			font-size: 2em;
			padding: 1rem;
			display: inline-block;
		}
		.next {
			grid-column: 2 / 3;
		}
		.home {
			grid-column: 3 / 4;
		}
		.previous {
			grid-column: 4 / 5;
		}

	}
	.detail-view {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 1.5fr 1fr;
		grid-gap: 2em;
		margin: 0 auto;
		padding: 2em 2em;
		font-weight: bold;

		.range-session-detail {
			grid-row: 1 / 3;
			position: relative;
		}

		.add-a-note {
			position: absolute;
			left: -2em;
			top: 4.9em;
			span {
				display: none;
				font-size: 0.75em;
				margin-top: 5px;
				text-align: center;
			}
		}
		.add-a-note:hover {
			span { display: inherit; }
		}

		.range-note-modal .inner {
			width: 60vw;
			// height: 60vh;
			padding: 2em;
			textarea {
				height: 7em;
			}
			.controls {
				grid-gap: 0 3em;
				background: none;
				display: grid;
				grid-template-columns: 1fr 1fr;
			}
			.previous-note {
				margin: 1em;
				font-weight: normal;
			}
		}

		.timer {
			justify-self: center;
		}


		label {
			display: grid;
			grid-template-columns: 1fr 2fr;
			grid-gap: 1rem;
			align-items: center;
			font-size: 1.3em;
			margin-bottom: 0.5rem;
		}
		input {
			margin: 0;
		}
		input[type=number] { width: 7.25em; }
		select.time-select {
			width: 3em;
			margin: 0;
		}

		.controls {
			grid-column: span 2;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr 1fr;
			grid-gap: 1em 1em;
			.button {
				margin-right: 0;
				width: 100%;
				position: relative;
			}
			.actiontarget_button {
				background-color: #0062A7;
				padding-left: 1em;
				img {
					height: 1.75em;
					position: absolute;
					top: 7px;
					left: 7px;
				}
			}
		}
		.adjust-time {
			position: relative;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-gap: 1rem;
			align-items: center;
			justify-items: center;
			div {
				border: 2px solid black;
			}
			.detail-time-remaining {
				font-size: 1.7em;
				padding: 1rem 2rem;
			}
			.button {
				//font-size: 1em;
				margin: 0;
				color: black;
				background-color: white;
				grid-row: 1 / 2;
				padding: 0.7rem;
				width: 48px;
			}
			.subtract-time { justify-self: end; }
			.add-time { justify-self: start; grid-column: 3 / 4; }
		}
	}

	button, .button {
		// grid-row: 2 / 3;
		background: $orange;
		color: white;
		font-size: 1.2em;
		text-transform: initial;
		font-weight: bold;
		display: inline-block;
		width: 70%;

		&.cancel-move {
			grid-row: 1 / 2;
		}
	}

	.time-view {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-gap: 2rem;
		margin: 2rem 4rem 4rem 4rem;
		overflow-x: hidden;
		overflow-y: scroll;
		height: 65vh;

		.clock, .timer {
			margin: 0 auto;
		}
		.clock, .clock .timer {
			width: 150px;
			height: 150px;
		}

		.description {
			text-align: center;
			margin-top: 5px;
		}
	}

	.clock {
		color: white;
		background: gray;
		justify-self: center;
		position: relative;
		border-radius: 100%;
		width: 200px;
		height: 200px;

		.timer {
			border-radius: 100%;
			height: 200px;
			width: 200px;
			position: relative;
		}

		.mask {
			border-radius: 100% 0 0 100% / 50% 0 0 50%;
			height: 100%;
			left: 0;
			position: absolute;
			top: 0;
			width: 50%;
			transform-origin: 100% 50%;
		}

		.time {
			position: absolute;
			z-index: 999;
			display: grid;
			align-items: center;
			justify-items: center;
			color: white;
			top: 0;
			font-size: 2.5em;
			bottom: 0;
			left: 0;
			right: 0;
		}
	}

	&.move-reservation-mode {
		.cell:not(.time):hover {
			cursor: pointer;
			border: 1px solid black;
		}
		.range-reservation:hover {
			cursor: not-allowed;
		}
	}

	.add-products-view {
		padding: 2em 8em;
		.controls {
			// grid-column: 1 / 5;
			display: grid;
			grid-template-columns: 1fr 1fr;
			align-items: baseline;
			margin-bottom: 2em;
			select {
				width: 60%;
				justify-self: start;
			}
			.button {
				width: 100%;
				margin-right: 0;
			}
		}
		ul.range-products {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr 1fr;
			list-style: none;
			grid-gap: 3em 1.5em;
			li {
				text-align: center;
				border: 1px solid #9a9a9a;
				padding: 1em 0.5em;
				display: grid;
				grid-template-rows: 1fr 1.25em 1.25em auto;
				grid-template-columns: 1fr 1fr;
				grid-gap: 5px;
				justify-items: center;
				align-items: center;
				user-select: none;
				img {
					max-width: 100%;
					max-height: 10em;
					margin-bottom: 1.25em;
					grid-column: 1 / 3;
				}
				.description, .upc { grid-column: 1 / 3; }
				.description {
					font-weight: bold;
				}
				.price { font-size: 1.5em; }
				select {
					width: 50%;
					margin: 0.5em 0 0 0;
				}
			}
			li.selected {
				border: 4px solid #d77325;
				padding: calc(1em - 3px) calc(0.5em - 3px);
			}
		}
	@media all and (max-width: 1250px) {
		padding: 2em;
	}
	@media all and (max-width: 780px) {
		ul.range-products { grid-template-columns: 1fr 1fr 1fr; }
	}
	}
}
.range_memberships_module {
	.navigation {
		max-width: 1200px;
		margin: 2em auto;
		display: grid;
		grid-template-columns: 1fr 24em 10em 10em 10em;
		align-items: end;
		text-align: center;
		font-size: 0.5em;
		i { font-size: 4em; }
		.refresh { grid-column-start: 3; }
		.refresh, .show-grid-view, .show-time-view { cursor: pointer; }
		div.disabled { background: none; color: grey; cursor: not-allowed; }
		.cancel-move {
			grid-column-start: 2;
			justify-self: start;
			align-self: center;
			font-size: 2em;
			width: auto;
		}

		.back-button {
			text-align: left;
			font-weight: bold;
			cursor: pointer;
			display: grid;
			grid-template-columns: 3em 1fr;
			align-items: center;
			span { font-size: 2.25em; }
		}

	}
}
</style>
